import { useState, useEffect } from "react";
import "../../styles/Instalador.css";

export const Instalador = ({ setIsInfoModalOpen, setIsStatsModalOpen }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);
  const [isIOS, setIsIOS] = useState(false);
  const [isSafari, setIsSafari] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Detectar si la app ya está instalada
    const isInStandaloneMode =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true; // Para Safari en iOS

    setIsInstalled(isInStandaloneMode);

    if (isInStandaloneMode) {
      setIsNavbarOpen(false);
    }

    // Detectar si el usuario usa iOS con Safari
    const userAgent = window.navigator.userAgent;
    const iosDetected = /iPad|iPhone|iPod/.test(userAgent);
    const safariDetected = /^((?!chrome|android).)*safari/i.test(userAgent);

    setIsIOS(iosDetected);
    setIsSafari(safariDetected);

    // Manejar el evento beforeinstallprompt (solo Android)
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (isInstalled) {
      alert("📲 La aplicación ya está instalada en tu dispositivo.");
      return;
    }

    if (isIOS && isSafari) {
      alert(
        "📲 Para instalar en iPhone:\n\n1️⃣ Abre el menú de Safari (📤).\n2️⃣ Selecciona 'Agregar a la pantalla de inicio'.\n3️⃣ Confirma el nombre y presiona 'Agregar'."
      );
    } else if (deferredPrompt) {
      // Mostrar el prompt de instalación en Android
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        console.log(
          choiceResult.outcome === "accepted"
            ? "El usuario aceptó la instalación"
            : "El usuario canceló la instalación"
        );
        setDeferredPrompt(null);
      });
    } else {
      alert("Este dispositivo ya tiene la aplicación instalada o no permite la instalación.");
    }
  };

  return isNavbarOpen ? (
    <div id="navbar2-container">
      <button onClick={() => setIsNavbarOpen(false)} className="navbar2-close-btn">
        <span>X</span>
      </button>
      <p>📲 Instala nuestro juego haciendo clic en el botón</p>
      <div>
        <button onClick={handleInstallClick} className="navbar2-install-btn">
          Instalar juego
        </button>
      </div>
    </div>
  ) : null;
};